import React, { useState } from 'react';

import failedIcon from '@images/failed.svg';
import { Button, useTranslation, Divider } from '@testsigma/atoms';

import { useConnectionFailed } from '../../hooks';
import { useSFConnectionState } from '@contexts/sf-connection-context';
import ErrorDetailsModal from '@modules/salesforce/common-models/detailed-connection-error-screen';

const UserConnectionFailedScreen: React.FC = () => {
  const { t } = useTranslation();
  const { handleGoBack } = useConnectionFailed();
  const { connectionError } = useSFConnectionState();
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);

  const handleViewConnectionError = () => {
    setIsErrorModalOpen(true);
  };

  const handleCloseErrorModal = () => {
    setIsErrorModalOpen(false);
  };

  return (
    <>
      <div className='flex items-center justify-center h-[60px]'>
        <div className='ml-8 items-center my-4 font-medium text-[18px] text-secondary-unique-600'>
          {t('connection-failed-status.label')}
        </div>
      </div>
      <Divider type='solid' />
      <div>
        <div className='flex mt-5 mb-8 px-10  flex-col items-center justify-center h-full'>
          <div className='text-gray-500 text-center flex flex-col items-center'>
            <img
              src={failedIcon}
              className='empty-illustration'
              alt='Tick Illustration'
            />
          </div>
          <span className='mt-3 text-15 font-semibold'>
            {t('connection-failed-status.description')}
          </span>
          <div
            className='my-10 text-sm leading-5 text-center'
            dangerouslySetInnerHTML={{
              __html: t('connection-failed-status.message'),
            }}
          />
          <Button type='secondary' onClick={handleViewConnectionError}>
            {t('common.view-connection-error.label')}
          </Button>
          <Button type='secondary' onClick={handleGoBack} className='mt-6'>
            {t('common.go-back.label')}
          </Button>
        </div>
      </div>

      <ErrorDetailsModal
        isOpen={isErrorModalOpen}
        onClose={handleCloseErrorModal}
        errorObject={connectionError}
      />
    </>
  );
};

export { UserConnectionFailedScreen };
